import { useRouteMatch } from "react-router-dom";
import News from "./News";

const NewsContainer: React.FC = () => {
  const { url } = useRouteMatch();
  return <News url={url} />;
};

export default NewsContainer;
